import React from "react"
import {
    Steps,
    Button,
    message,
    SuiNumber,
    SuiInput,
    SuiSelect,
    SuiForm,
    Row
} from "@sudy/sui-react"
// import optionsStore from './stores/optionsStore';
import optionsStore from "../../stores/optionsStore"
import { Result } from "antd"
import { observable } from "mobx"
import { observer } from "mobx-react"
import postStore from "../../stores/postStore"
import { $attrs } from "@sudy/sui-react/lib/sui/bind"
import apis from "../../util/urls"
import $ from "jquery"
import { Form ,Input} from "antd"


const imgUrl = `${apis.getCode}?tt=${new Date().getTime()}`

class MessCheck extends React.Component {
    constructor(props) {
        super(props)
        // this.msgRef = React.createRef()

        this.state = {
            current: 0,
        }
    }

    // 修改验证码
    changeCode(e){
        // console.log(this.vscodeNode)
        // alert(`${apis.getCode}?tt=${new Date().getTime()}`)
        this.vscodeNode.src = `${apis.getCode}?tt=${new Date().getTime()}`
    }

    // 获取参数
    getValue() {
        if (!this.messCheckNode.verify()) {
            // message.info('请检查输入项');
            return false ;
        } else {
            console.log(this.messCheckNode.getFieldsValue())
            return this.messCheckNode.getFieldsValue()
        }
        // this.messCheckNode.ve
        

        // const form = this.formRef.props.form
        // form.validateFields((err, fieldsValue) => {
        //     if (!err) {
        //         console.log(fieldsValue)
        //     }
        // })
    }

    queryData(cur) {
        $.ajax({
            url: this.steps[cur].url,
            type: "post",
            dataType: "json",
            data: this.getParams(),
            success: function (response) {},
            error: function (xhr) {},
            complete: function () {},
        })
    }

    render() {
        let count = 0;
        return (
            <div span={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <SuiForm
                    // bind={postStore}
                    ref={(node) => {
                        this.messCheckNode = node
                    }}
                    layout={"vertical"}
                >
                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>学工号：
                        </p> */}

                        <SuiInput
                            name="loginName"
                            required
                            tip="请输入学工号"
                            style={{ width: "100%" }}
                            placeholder="请输入学工号"
                        />
                    </div>
                    {/* <div className="app-item">
                        <p>
                            <span className="ids-star">*</span>证件类型：
                        </p>
                        <SuiSelect
                            name="idType"
                            options={optionsStore.IDs}
                            defaultValue={"sfz"}
                        />
                    </div> */}
                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>身份证号：
                        </p> */}
                        <SuiInput
                            name="idNumber"
                            style={{ width: "100%" }}
                            required
                            tip="请输入身份证号"
                            defaultValue={""}
                            placeholder="请输入身份证号"
                        />
                    </div>
                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>验证码：
                        </p> */}
                        <div
                            style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-start",
                            }}
                        >
                            <SuiInput
                                style={{ backgroundColor: "transparent" }}
                                className={"borders"}
                                name="validateCode"
                                // addonAfter={
                                //     <img
                                //         alt=""
                                //         ref={(node) => (this.vscodeNode = node)}
                                //         src={imgUrl}
                                //         style={{ height: 32, width: 125 }}
                                //         onClick={(e) => this.changeCode(e)}
                                //     />
                                // }
                                placeholder="请输入验证码"
                                onSearch={() => {
                                    return this.sendMsg()
                                }}
                                required
                                tip="请输入验证码"
                            />

                            <img
                                alt=""
                                ref={(node) => (this.vscodeNode = node)}
                                src={imgUrl}
                                className={"ids_vscode"}
                                // style={{
                                //     height: 32,
                                //     width: 95,
                                //     borderRadius: 4,
                                //     marginLeft: 5,
                                // }}
                                onClick={(e) => this.changeCode(e)}
                            />
                        </div>
                    </div>
                </SuiForm>
            </div>
        )
    }

 
}
export default MessCheck
